import classNames from 'classnames';
import styles from './SEOText.module.scss';

const SEOText = ({ children, className }) => {
  return (
    <div
      className={classNames([styles.content, className])}
      dangerouslySetInnerHTML={{ __html: children }}
      data-testid='seo-text'
      itemScope
      itemType='https://schema.org/Person'
    />
  );
};

export default SEOText;
